export default "__VITE_ASSET__gcFTtWuG__"